import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  PLATFORM_ID,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {TranslationService} from "../../../core/services/translation.service";
import {Offer} from "../../../data/models/offer.model";
import {ConfigService} from "../../../core/services/config.service";
import {Bonus} from "../../../data/models/bonus.model";
import {OfferPrice} from "../../../data/models/price.model";
import {BaseData} from "../../../data/models/base-data.model";
import {MatStepper} from "@angular/material/stepper";
import {DomSanitizer} from "@angular/platform-browser";
import {NavigationCommand, NavigationService} from "../../../data/services/navigation.service";
import {PaymentProviderService} from "../../../core/services/payment-provider.service";
import {isPlatformBrowser} from "@angular/common";
import {OrderResultModel} from "../../../data/models/orderResult.model";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {ImageService} from '../../../core/services/image.service';

@Component({
  selector: 'app-offer-card',
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.css']
})
export class OfferCardComponent implements OnChanges {
  console = console;

  @Input() offer: Offer;
  @Input() showOnOfferPage: boolean = true;
  @Input() bonuses: Bonus[];
  @Input() deliveryAddress: any;
  @Input() billingAddress: any;
  @Input() bonusAddress: any;
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() prices: OfferPrice[];
  @Input() paymentCode: BaseData;
  @Input() paymentFrequency: BaseData;
  @Input() stepper: MatStepper;
  @Input() creatingOrder: boolean = false;
  @Input() onlinePayment: boolean = false;
  @Input() privacyDisclaimerAgbInOne: boolean = false;
  @Input() showOnlyOptIns: boolean = false;
  @Output() save: EventEmitter<OrderResultModel> = new EventEmitter<OrderResultModel>();
  @Output() optInsSelected: EventEmitter<Map<number,  boolean>> = new EventEmitter<Map<number,  boolean>>();
  highlightIds: string[];
  @ViewChild('saveButtonPoint')saveButtonPoint: ElementRef<HTMLElement>;
  @ViewChild('offerCard')offerCard: ElementRef<HTMLElement>;
  orderResult: OrderResultModel = {agb: false, privacy: false, disclaimer: false, paymentTransaction: null};

  agb: boolean = false;
  privacy:boolean = false;
  disclaimer: boolean = false;
  privacyDisclaimerAgb:boolean = false;
  checkBoxes: boolean = false;

  optinResult: Map<number, boolean>;

  additionalAgbInfo1: string;
  additionalAgbInfo2: string;

  showPrice: boolean = false;
  @Output() agbChecked = new EventEmitter<boolean>();

  constructor(
    private navigationService: NavigationService,
    public translationService: TranslationService,
    public configService: ConfigService,
    public sanitizer: DomSanitizer,
    private paymentProvider: PaymentProviderService,
    protected imageService: ImageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    const offerIds = this.configService.getConfig('offer.highlight.offerId');
    if (offerIds?.value !== '') {
      this.highlightIds = offerIds?.value?.split(',');
    }

    const showPriceConfig = this.configService.getConfig('offer.card.showPrice');
    if (showPriceConfig?.value == '1' || showPriceConfig?.value == 'true' ) {
      this.showPrice = true;
    }

    this.paymentProvider.getPaymentProviderResultData().subscribe(transaction => {
      if (transaction && transaction?.transactionId && transaction.transactionId !== '') {
        this.orderResult.paymentTransaction = transaction;
        this.saveOrder();
      }
    });

    this.optinResult = new Map<number, boolean> ();

    this.additionalAgbInfo1 = this.translationService.getTranslation("offer.additionalInfo.beforeAgb");
    this.additionalAgbInfo2 = this.translationService.getTranslation("offer.additionalInfo.afterAgb");
  }

  checkBoxesChecked(): boolean {
    this.checkBoxes = true;
    return (this.agb && this.privacy && this.disclaimer || this.privacyDisclaimerAgb);
  }

  openOrder(id: number): void{
    this.navigationService.navigateTo(NavigationCommand.OFFER, new Array(id+'')).then(() => {});
  }

  saveOrder(): void {
    if (this.checkBoxesChecked()) {
      this.orderResult.agb = true;
      this.orderResult.privacy = true;
      this.orderResult.disclaimer = true;
      this.save.emit(this.orderResult);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId) && changes.prices && !changes.prices.firstChange) {
      const elementPosition = this.saveButtonPoint?.nativeElement?.getBoundingClientRect()?.top;
      const cardPosition = this.offerCard?.nativeElement?.getBoundingClientRect();
      const absoluteElementTop = cardPosition?.top + window.scrollY;
      const middle = absoluteElementTop - (cardPosition?.height / 2);

      if ( elementPosition && elementPosition > 0) {
        window.scrollBy({left: 0, top: middle, behavior: 'smooth'});
      }

      if (changes['onlinePayment']) {
        this.onlinePayment = changes['onlinePayment'].currentValue;
      }
    }
  }

  onOptInClick(event, optin): void {
    this.optinResult.set(optin.id, event.checked);
    this.optInsSelected.emit(this.optinResult);
  }

  isOptinValid(): boolean {
    this.offer.optIns.forEach(e => {
      if(e.mandatory && !this.optinResult.get(e.id)) {
        return false;
      }
    })
    return true;
  }

  checkAgb() {
    this.agbChecked.emit(this.checkBoxesChecked());
  }
}
